import { RichTextNode } from '../types/aiArticle';

// リッチテキストを文字列に変換する関数
export const richTextToString = (richText: string | RichTextNode[] | undefined): string => {
  if (!richText) return '';

  if (typeof richText === 'string') {
    return richText;
  }

  if (Array.isArray(richText)) {
    return richText
      .map(node => {
        if (node.children) {
          return node.children.map(child => child.text || '').join('');
        }
        return '';
      })
      .join(' ');
  }

  return '';
};

// リッチテキストをHTMLに変換する関数（記事詳細用）
export const richTextToHtml = (richText: string | RichTextNode[] | undefined): string => {
  if (!richText) return '';

  if (typeof richText === 'string') {
    return richText;
  }

  if (Array.isArray(richText)) {
    return richText
      .map(node => {
        if (node.type === 'paragraph') {
          const text = node.children.map(child => child.text || '').join('');
          return `<p>${text}</p>`;
        }
        if (node.type === 'heading') {
          const text = node.children.map(child => child.text || '').join('');
          return `<h2>${text}</h2>`;
        }
        // その他のタイプも必要に応じて追加
        const text = node.children.map(child => child.text || '').join('');
        return `<p>${text}</p>`;
      })
      .join('');
  }

  return '';
};
